/* Standard Shopify product and cart forms; no local basket or fabricated analytics. */
(() => {
  document.addEventListener('click', event => { const link=event.target.closest('.ca-mobile-menu a'); if(link)link.closest('details').open=false; });
  document.addEventListener('keydown', event => {if(event.key==='Escape')document.querySelectorAll('.ca-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  document.addEventListener('change', event => {
    if(!event.target.matches('[data-ca-variant]'))return;
    const url=new URL(event.target.dataset.productUrl,window.location.origin);url.searchParams.set('variant',event.target.value);window.location.assign(url.href);
  });
})();
